import * as FormTypes from './compositions/Form/Form/types';
import * as LocatorTypes from './compositions/Locator/types';
export { FormTypes, LocatorTypes };
export var Brand;
(function (Brand) {
    Brand["Arket"] = "arket";
    Brand["COS"] = "cos";
    Brand["HM"] = "hm";
    Brand["Monki"] = "monki";
    Brand["Northstar"] = "northstar";
    Brand["OtherStories"] = "otherStories";
    Brand["Weekday"] = "weekday";
})(Brand || (Brand = {}));
//# sourceMappingURL=types.js.map